import type { RacemapEventCommon } from '@racemap/utilities/types/events';
import type { Immutable } from 'immer';

export async function eventHasAssociates(
  event: RacemapEventCommon,
  associatedUsers: Immutable<Set<string>>,
): Promise<boolean> {
  if (associatedUsers.has(event.creatorId)) return true;

  return event.editorIds?.some((editorId) => associatedUsers.has(editorId));
}
